export function buildFormSessionUrl(origin, formId, sessionId, testId) {
  const parts = testId === undefined
    ? ['form', formId, sessionId]
    : ['form', 'form_test', formId, testId, sessionId];
  return `${origin.replace(/\/$/, '')}/${parts.map(encodeURIComponent).join('/')}`;
}
